export const reParts = {
    street  : {
        pattern : "\\d+[a-zA-Z0-9\\s.,'#-]{2,100}",
    },
    city    : {
        pattern : "[a-zA-Z\\s.-]{2,50}",
    },
    state   : {
        pattern : "A[KLRZ]|C[AOT]|D[CE]|F[LM]|G[AU]|HI|I[ADLN]|K[SY]|L[A]|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[ATIT]|W[AIVY]",
        text    : "state needs to look like two capital letters"
    },
    zip     : {
        pattern : "[0-9]{5}(?:-[0-9]{4})?",
        text    : "Zip code needs to look like 5 digits, optionally followed by a dash and 4 more digits"
    }
} as Record<string,{
    pattern : string;
    text?   : string;
}>;

export const rePattern = Object.entries(reParts).map( ([name,re]) => {
    return `(?<${name}>${re.pattern})`;
}).join(",\\s*");

export const re = new RegExp(`^${rePattern}$`,"");

export const match = ( usAddress:string, comprehensiveParsing:boolean=false ) => {
    if( !comprehensiveParsing )
        return (usAddress||'').trim().match(re)?.groups;
    // Street is the most "greedy" part of the start, so let's start from
    // the end and parse backwards
    return Object.entries(reParts).reverse().reduce( (acc,[name,re]) => {
        const partRE        = new RegExp(
            (name==='street') 
                ? `^(?<${name}>${re.pattern})$`
                : `^(?<start>.+)[,\\s]\\s*(?<${name}>${re.pattern})$`
        );
        const partMatches   = acc.start.trim().match(partRE);
        /*
        console.log({
            partRE,
            partMatches,
            acc
        });
        */
        if( !partMatches ) {
            if( re.text )
                throw Error(`Cannot parse "${name}" (${re.text})`);
            throw Error(`Cannot parse "${name}"`);
        }
        acc.start         = partMatches.groups!.start?.replace(/[\s,]+$/,"");
        acc.matches[name] = partMatches.groups![name];
        return acc;
    },{
        start   : (usAddress||''),
        matches : {} as Record<string,string>
    }).matches;
}

export default match;